import { jsx as o } from "react/jsx-runtime";
import r from "@kmx/mui-icons/KmxChevronLeftStroked";
import t from "@kmx/mui-icons/KmxChevronRightStroked";
import e from "@kmx/mui-icons/KmxSkipNextFilled";
import i from "@kmx/mui-icons/KmxSkipPreviousFilled";
const x = {
  defaultProps: {
    slotProps: {
      first: /* @__PURE__ */ o(i, {}),
      next: /* @__PURE__ */ o(t, {}),
      previous: /* @__PURE__ */ o(r, {}),
      last: /* @__PURE__ */ o(e, {})
    }
  }
};
export {
  x as default
};
